import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import {
  cleanCsvString,
  delete_Record,
  errorMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetCustomerDDLList,
  POST_GetEmployeeDDLList,
  POST_GetInwardMaterialReturnToReturnerList,
  POST_InwardMaterialGetDetailByIDForReturnToReturnerANDSampleDispose,
  POST_InwardMaterialReturnToReturnerInsert,
} from "../../../helpers/url_helper";
import moment from "moment";
import { useFilter } from "../../../../context/FilterContext";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const SampleReturnToReturner = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "sample-return-to-returner-list"
      ? filter?.CurrentPage
      : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "sample-return-to-returner-list"
      ? filter?.PageSize
      : 10,
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "sample-return-to-returner-list"
      ? filter?.sortBy
      : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "sample-return-to-returner-list"
      ? filter?.orderBy
      : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  const [customerOptionList, setCustomerList] = useState([]);
  const [tCNumber, setTCNumber] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaReporting = Yup.object().shape({});
  const formik = useFormik({
    validationSchemaReporting,
    onSubmit: (values, formikHelpers) =>
      handleValidReportingSubmit(values, formikHelpers),
    initialValues: {
      SampleReturnToReturnerList: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidReportingSubmit,
    values: { SampleReturnToReturnerList },
  } = formik;

  const validationSchema = Yup.object().shape({});

  const currentDate = new Date();

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TCNo:
        filter && filter?.page == "sample-return-to-returner-list"
          ? filter?.TCNo
          : "",
      InwardNo:
        filter && filter?.page == "sample-return-to-returner-list"
          ? filter?.InwardNo
          : "",
      FromDate:
        filter && filter?.page == "sample-return-to-returner-list"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 2)),
      ToDate:
        filter && filter?.page == "sample-return-to-returner-list"
          ? filter?.ToDate
          : new Date(),

      Search:
        filter && filter?.page == "sample-return-to-returner-list"
          ? filter?.Search
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { TCNo, FromDate, ToDate, InwardNo, Search },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      TCNo: "",
      InwardNo: "",
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 2)),
      ToDate: new Date(),
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "sample-return-to-returner-list",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Search: Search,
      TCNo: TCNo,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      TCNo: TCNo,
      InwardNo: InwardNo,
      CustomerIDEncrypted: "",
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetInwardMaterialReturnToReturnerList, payload)
      .then((response) => {
        formik.setFieldValue(
          "SampleReturnToReturnerList",
          response?.List?.map((item) => ({
            ...item,
            showTest: false,
          })),
        );
        setRecordCount(response?.TotalRecordCount);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // getCustomerDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const [
    showInwardMaterialReturnToReturnerModal,
    setShowInwardMaterialReturnToReturnerModal,
  ] = useState(false);

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            })),
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1) {
            formikInwardMaterialReturnToReturner.setFieldValue(
              "ReturnToEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaInwardMaterialReturnToReturner = Yup.object().shape({
    ReturnToEncrypted: Yup.string().required("Return To is required field"),
  });

  const formikInwardMaterialReturnToReturner = useFormik({
    validationSchema: validationSchemaInwardMaterialReturnToReturner,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitInwardMaterialReturnToReturner(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      InwardNo: "",
      InwardDate: "",
      CustomerName: "",
      Size: "",
      Condition: "",
      SampleDetail: "",
      ProjectDetails: "",
      LetterRefNo: "",
      IsTPIRequired: false,
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      TCNo: "",
      SamplePacking: "",
      LotNo: "",
      MfgDate: "",
      ExpDate: "",
      CustomerProvidedSampleDetail: "",
      Marking: "",
      SampleBatchCode: "",
      SamplingByName: "",
      SampleDrawnBy: "",
      ReturnDate: "",
      ReturnToEncrypted: "",
      ReturnToReturnerRemarks: "",
      DisposeDate: "",
      DisposeBy: "",
      SampleDisposeRemarks: "",
      InwardMaterialReturnToReturnerIDEncrypted: "",
      InwardMaterialSampleDisposeIDEncrypted: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { ReturnDate, ReturnToEncrypted },
  } = formikInwardMaterialReturnToReturner;

  const handleValidSubmitInwardMaterialReturnToReturner = (values) => {
    let payload = {
      InwardIDEncrypted: values?.InwardIDEncrypted,
      InwardMaterialIDEncrypted: values?.InwardMaterialIDEncrypted,
      ReturnToEncrypted: values?.ReturnToEncrypted,
      ReturnOn: values?.ReturnOn,
      Remarks: values?.ReturnToReturnerRemarks,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };
    post(POST_InwardMaterialReturnToReturnerInsert, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setIsLoading(false);
          setShowInwardMaterialReturnToReturnerModal(false);
          getData(currentPage, currentSizePerPage);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const openSampleReturnToReturnerDialog = async (InwardMaterialID, index) => {
    setIsLoading(true);
    getEmployeeDDL();

    await post(
      POST_InwardMaterialGetDetailByIDForReturnToReturnerANDSampleDispose,
      {
        InwardMaterialIDEncrypted: InwardMaterialID,
      },
    )
      .then((response) => {
        if (response?.IsSuccess) {
          formikInwardMaterialReturnToReturner.resetForm();
          formikInwardMaterialReturnToReturner.setValues({
            ...response,
          });
        }
        setIsLoading(false);
        setShowInwardMaterialReturnToReturnerModal(true);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Sample Return To Returner List</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "} Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>

                          {/* <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerID"
                              placeholder={"Select Customer"}
                              options={customerOptionList}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col> */}

                          <Col lg={3}>
                            <div className="d-flex">
                              <Field
                                label="From Date"
                                name="FromDate"
                                placeholder={"Select From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />

                              <div>&nbsp;</div>
                              <Field
                                label="To Date"
                                name="ToDate"
                                placeholder={"Select To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={2}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="SampleReturnToReturnerList-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="SampleReturnToReturnerList-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="3%"></th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No/Date{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {/* <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th> */}
                        <th
                          style={{
                            width: "20%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("SampleDetail");
                          }}
                        >
                          Sample Detail{" "}
                          <span className="ml-1">
                            {sortBy == "SampleDetail" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("EDD");
                          }}
                        >
                          EDD{" "}
                          <span className="ml-1">
                            {sortBy == "EDD" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ReturnDate");
                          }}
                        >
                          Return Date{" "}
                          <span className="ml-1">
                            {sortBy == "ReturnDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("ReturnTo");
                          }}
                        >
                          Return To{" "}
                          <span className="ml-1">
                            {sortBy == "ReturnTo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {SampleReturnToReturnerList?.length > 0 ? (
                        SampleReturnToReturnerList?.map((item, indx) => (
                          <React.Fragment key={indx}>
                            <tr key={indx} style={{ cursor: "pointer" }}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "center",
                                }}
                              >
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 106 && (x?.IsAdd || x?.IsEdit),
                                )?.length > 0 ? (
                                  item?.InwardMaterialReturnToReturnerIDEncrypted ? (
                                    ""
                                  ) : (
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        if (
                                          item?.InwardMaterialReturnToReturnerIDEncrypted ===
                                          ""
                                        ) {
                                          openSampleReturnToReturnerDialog(
                                            item?.InwardMaterialIDEncrypted,
                                            indx,
                                          );
                                        }
                                      }}
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  )
                                ) : (
                                  ""
                                )}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.TCNo}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.InwardNo}
                              </td>
                              {/* <td style={{ verticalAlign: "top" }}>
                                {item.CustomerName}
                              </td> */}
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                  cursor: "pointer",
                                }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.SampleDetail}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.SampleDetail}</span>
                                </OverlayTrigger>
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.EDD}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item?.ReturnDate}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                              >
                                {item?.ReturnTo}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showInwardMaterialReturnToReturnerModal}
            onHide={setShowInwardMaterialReturnToReturnerModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikInwardMaterialReturnToReturner}>
                <Form
                  onSubmit={formikInwardMaterialReturnToReturner.handleSubmit}
                >
                  <Modal.Header>
                    <Modal.Title>
                      Inward Material Return To Returner
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowInwardMaterialReturnToReturnerModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={4}>
                        <label>TC No :</label>{" "}
                        {formikInwardMaterialReturnToReturner.values.TCNo}
                      </Col>
                      <Col lg={4}>
                        <label>Inward Date :</label>{" "}
                        {formikInwardMaterialReturnToReturner.values.InwardDate}
                      </Col>
                      <Col lg={4}>
                        <label>Inward No :</label>{" "}
                        {formikInwardMaterialReturnToReturner.values.InwardNo}
                      </Col>
                      <Col lg={4}>
                        <label>Condition :</label>{" "}
                        {formikInwardMaterialReturnToReturner.values.Condition}
                      </Col>
                      <Col lg={4}>
                        <label>Size :</label>{" "}
                        {formikInwardMaterialReturnToReturner.values.Size}
                      </Col>
                      <Col lg={12}>
                        <label>Sample Detail :</label>{" "}
                        {
                          formikInwardMaterialReturnToReturner.values
                            .SampleDetail
                        }
                      </Col>
                      <hr className="mt-1 mb-1"></hr>

                      <Col lg={4}>
                        <Field
                          label="Return To"
                          name={"ReturnToEncrypted"}
                          placeholder={"Select Return To"}
                          options={employeeOptions}
                          component={CustomSelect}
                          required
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Return On"
                          name={"ReturnOn"}
                          placeholder={"Return On"}
                          component={CustomInput}
                          value={moment(new Date())
                            .format("DD-MMM-YYYY hh:mm a")
                            .replace(/^\-/, "")}
                          disabled={true}
                        />
                      </Col>

                      <Col lg={8}>
                        <Field
                          label="Remarks"
                          name={"ReturnToReturnerRemarks"}
                          placeholder={"Remarks"}
                          component={CustomTextArea}
                          rows={3}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowInwardMaterialReturnToReturnerModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default SampleReturnToReturner;
